export const formatDuration = (duration) =>
	duration
		.replace("PT", "")
		.replace("D", "d ")
		.replace("H", "h ")
		.replace("M", "m");

export const titleCase = (str) => {
	str = str.toLowerCase();
	str = str.split(" ");
	for (let i = 0; i < str.length; i++)
		str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
	return str.join(" ");
	// ["I'm", "A", "Little", "Tea", "Pot"].join(' ') => "I'm A Little Tea Pot"
};

/**
 * Simple int32 hashcode of stringified obj
 * @param obj anything, including a primitive value
 * @returns {number} int32
 */
export const hashCode = (obj) => {
	const str = JSON.stringify(obj);
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
};

/**
 *
 * @param obj
 * @param extractor return an object with fields relevant to signature
 * @returns {string}
 */
export const getSignature = (obj, extractor = (x) => x) => {
	return Math.abs(hashCode(extractor(obj))).toString(36);
};

export const findBySignature = (items, signature, extractor) => {
	const matching = items.filter(
		(obj) => getSignature(extractor(obj)) === signature,
	);
	if (matching.length === 1) {
		return matching[0];
	}
	return undefined;
};

const flightSignatureExtractor = (flight) =>
	flight.itineraries.map((i) =>
		i.segments.map((s) => [s.carrierCode, s.carrierNumber, s.departureAt]),
	);

export const getFlightSignature = (flight) =>
	getSignature(flight, flightSignatureExtractor);

export const findFlightBySignature = (flights, signature) =>
	findBySignature(flights, signature, flightSignatureExtractor);

/*
 * Get the day of the year for a given date
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} Jan 1st -> 1 etc
 */
export const getDayOfYear = (isoDateStr) => {
	if (!isoDateStr) {
		return undefined;
	}
	const date = new Date(isoDateStr);
	const startOfYear = new Date(date.getFullYear(), 0, 0);
	const diff = date - startOfYear;
	const oneDay = 1000 * 60 * 60 * 24;
	return Math.floor(diff / oneDay);
};

/*
 * Get the number of seconds since 1970-01-01
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} seconds
 */
export const getEpochSeconds = (isoDateStr) => {
	return isoDateStr
		? Math.floor(new Date(isoDateStr).getTime() / 1000)
		: undefined;
};

/*
 * Get the number of seconds since 1970-01-01
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} seconds
 */
export const getWeekOfYear = (isoDateStr) => {
	return isoDateStr ? Math.floor(getDayOfYear(isoDateStr) / 7) : undefined;
};

/*
 * Get the year of date string
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} year
 */
export const getYear = (isoDateStr) => {
	return isoDateStr ? Number(isoDateStr.substring(0, 4)) : undefined;
};

/*
 * Get the month of date string
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} month
 */
export const getMonth = (isoDateStr) => {
	return isoDateStr ? new Date(isoDateStr).getMonth() : undefined;
};

const secondsPerDay = 86400;

/*
 * Days from one isodate string to another, including the starting date,
 * ie same dates have a duration of 1
 * @param {string} isoDateStr ISO date string eg '2025-12-31'
 * @returns {number} year
 */
export const getDurationDays = (isoDateStrFirst, isoDateStrLast) => {
	if (!isoDateStrFirst || !isoDateStrLast) {
		return undefined;
	}
	return (
		1 +
		(getEpochSeconds(isoDateStrLast) - getEpochSeconds(isoDateStrFirst)) /
			secondsPerDay
	);
};
